// extracted by mini-css-extract-plugin
module.exports = {"arrow-container":"styles__arrow-container___3tQ_J","arrow":"styles__arrow___1uAUr","icon":"styles__icon___2yK_b"};